import { observer } from 'mobx-react';
import React, { Component } from 'react';
import ProjectSelect from '../../Projects/ProjectSelect';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import SaleStore from '../SaleStore';
import SaleDialog from '../SaleDialog';
import UserAvatar from '../../Users/UserAvatar';
import ProjectTypeSelect from '../../Projects/ProjectTypeSelect';

const SaleArchiveBoard = observer(class SaleArchiveBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sales: [],
            emptyProject: !localStorage.getItem('filter_sale_archive_emptyProject') ? true : localStorage.getItem('filter_sale_archive_emptyProject') === 'true',
            isWin: !localStorage.getItem('filter_sale_archive_isWin') ? true : localStorage.getItem('filter_sale_archive_isWin') === 'true',
            filterProjectId: (localStorage.getItem('filter_sale_archive_ProjectId') !== 'null' && !!localStorage.getItem('filter_sale_archive_ProjectId')) ? localStorage.getItem('filter_sale_archive_ProjectId') : '',
            filterProjectName: (localStorage.getItem('filter_sale_archive_ProjectName') !== 'null') ? localStorage.getItem('filter_sale_archive_ProjectName') : '',
            filterProjectTypeId: (localStorage.getItem('filter_sale_archive_ProjectTypeId') !== 'null' && !!localStorage.getItem('filter_sale_archive_ProjectTypeId')) ? localStorage.getItem('filter_sale_archive_ProjectTypeId') : '',
            filterProjectTypeName: (localStorage.getItem('filter_sale_archive_ProjectTypeName') !== 'null') ? localStorage.getItem('filter_sale_archive_ProjectTypeName') : '',
        };

        this.loadSales = this.loadSales.bind(this);
        this.handleQuickFilterEmptyProjectChange = this.handleQuickFilterEmptyProjectChange.bind(this);
        this.handleQuickFilterProjectChange = this.handleQuickFilterProjectChange.bind(this);
        this.handleQuickFilterProjectTypeChange = this.handleQuickFilterProjectTypeChange.bind(this);
        this.handleQuickFilterIsWinChange = this.handleQuickFilterIsWinChange.bind(this);
    }

    componentDidMount() {
        this.loadSales();
    }

    loadSales() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Sale/GetClosedSales?isEmptyProject=' + this.state.emptyProject + '&isWin=' + this.state.isWin + '&projectId=' + this.state.filterProjectId + '&projectTypeId=' + this.state.filterProjectTypeId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ sales: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleQuickFilterIsWinChange(evt) {
        var isWin = evt.target.checked;
        localStorage.setItem('filter_sale_archive_isWin', isWin);
        this.setState({ isWin: isWin }, () => this.loadSales());
    }

    handleQuickFilterEmptyProjectChange(evt) {
        var emptyProject = evt.target.checked;
        localStorage.setItem('filter_sale_archive_emptyProject', emptyProject);
        this.setState({ emptyProject: emptyProject }, () => this.loadSales());
    }

    handleQuickFilterProjectChange(project) {
        if (project) {
            localStorage.setItem('filter_sale_archive_ProjectId', project.id);
            localStorage.setItem('filter_sale_archive_ProjectName', project.name);
            this.setState({ filterProjectId: project.id, filterProjectName: project.name }, () => { this.loadSales() });
        }
        else {
            localStorage.setItem('filter_sale_archive_ProjectId', '');
            localStorage.setItem('filter_sale_archive_ProjectName', '');
            this.setState({ filterProjectId: '', filterProjectName: '' }, () => { this.loadSales() });
        }
    }

    handleQuickFilterProjectTypeChange(type) {
        if (type && type.id) {
            localStorage.setItem('filter_sale_archive_ProjectTypeId', type.id);
            localStorage.setItem('filter_sale_archive_ProjectTypeName', type.name);
            this.setState({ filterProjectTypeId: type.id, filterProjectTypeName: type.name }, () => { this.loadSales() });
        }
        else {
            localStorage.setItem('filter_sale_archive_ProjectTypeId', '');
            localStorage.setItem('filter_sale_archive_ProjectTypeName', '');
            this.setState({ filterProjectTypeId: '', filterProjectTypeName: '' }, () => { this.loadSales() });
        }
    }

    render() {
        return (
            <div>
                <h2>Данная сттаница находится в разработке</h2>
                <div className="quick-filter-panel clearfix">
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.emptyProject} onChange={this.handleQuickFilterEmptyProjectChange} value="true" />
                            }
                            label="Без проекта"
                        />
                    </div>
                    <div className="quick-filter-item">
                        <FormControlLabel
                            control={
                                <Checkbox checked={this.state.isWin} onChange={this.handleQuickFilterIsWinChange} value="true" />
                            }
                            label="Победа"
                        />
                    </div>
                    
                    <div className="quick-filter-item">
                        <ProjectSelect name={this.state.filterProjectName} handleSelect={this.handleQuickFilterProjectChange} />
                    </div>
                    <div className="quick-filter-item">
                        <ProjectTypeSelect label="Тип проекта" name={this.state.filterProjectTypeName} handleSelect={this.handleQuickFilterProjectTypeChange}  />
                    </div>
                </div>
                <div className="sale-archive-list">
                    {this.state.sales.map(s => <div className="sale-archive-card">
                        <div>
                            {s.number} {s.caption}
                            <IconButton onClick={() => SaleStore.openSaleDialog(s)} size="large">
                                <EditIcon />
                            </IconButton>
                            <div className="sale-archive-avatar">
                                <UserAvatar userId={s.ownerId} />
                            </div>
                        </div>
                        <div>
                            {s.account}
                            
                        </div>
                        <div>
                            {s.projectTypeName} {s.project}
                        </div>
                       
                    </div>)}
                </div>

                <SaleDialog />
            </div>
        );
    }
});

export default SaleArchiveBoard;